// @flow

// Libs
import { createSelector } from 'reselect'
import _indexOf from 'lodash/indexOf'
import _keyBy from 'lodash/keyBy'

// Utils
import emptyObjectOr from 'fc-utils/emptyObjectOr'

// Selectors
import selectedFarmId$ from './selectedFarmId'
import selectedSeasonId$ from './selectedSeasonId'
import fields$ from 'fc-assets/src/selectors/fields'
import ancestorsIndex$ from 'fc-assets/src/selectors/ancestorsIndex'

// Constants
import { PROP_ASSET_ID, PROP_SEASON } from 'fc-model-assets'

// Types
import type { Asset } from 'fc-model-assets/types'

// Exports
export default createSelector([
  selectedFarmId$,
  selectedSeasonId$,
  fields$,
  ancestorsIndex$,
], (farmId: number, seasonId: number, fields: Array<Asset>, ancestors: Object): Object => {
  const fieldsInSeasonOfFarm = fields.filter((field: Asset): boolean => {
    const assetId = field[PROP_ASSET_ID]

    return (_indexOf(ancestors[assetId], farmId) > -1) && (field[PROP_SEASON] === seasonId)
  })

  return emptyObjectOr(_keyBy(fieldsInSeasonOfFarm, PROP_ASSET_ID))
})
